export default __webpack_public_path__ + "static/media/adeniyi.480e93f1.png";